import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalculator = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 2.5,
			width: 14,
			height: 19,
			rx: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8.5,
			y1: 6.5,
			x2: 15.5,
			y2: 6.5
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8.5,
			y1: 11,
			x2: 8.5,
			y2: 11.01
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 11,
			x2: 12,
			y2: 11.01
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 15.5,
			y1: 11,
			x2: 15.5,
			y2: 11.01
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8.5,
			y1: 14.5,
			x2: 8.5,
			y2: 14.51
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 14.5,
			x2: 12,
			y2: 14.51
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 15.5,
			y1: 14.5,
			x2: 15.5,
			y2: 18
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 8.5,
			y1: 18,
			x2: 8.5,
			y2: 18.01
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 12,
			y1: 18,
			x2: 12,
			y2: 18.01
		})
	]
});
export default SvgCalculator;
